import { useTranslation } from 'react-i18next'
import { useFormContext } from '../../../../../../core/providers/FormProvider'
import QuestionSliderSettingRow from '../../components/inputs/QuestionSliderSettingRow'

const MiscSettings: React.FC = () => {
  const { t } = useTranslation()
  const {
    question: [question],
    updateQuestion,
  } = useFormContext()

  const misc = question?.__settings?.misc

  if (!misc) return null

  return (
    <>
      {Object.entries(misc)
        .filter(([, value]) => value !== undefined)
        .map(([property, value]) => (
          <QuestionSliderSettingRow
            key={`${question.__uuid}-label-settings-${property}`}
            title={t(`forms.settings.options.${property}`)}
            description={t(`forms.settings.options.${property}_description`)}
            onChange={() => updateQuestion({ __settings: { misc: { [property]: !value } } })}
            checked={!!value}
          />
        ))}
    </>
  )
}

export default MiscSettings
